import posthog from "posthog-js";
import { Config } from "@/lib/config";
import { captureException } from "@/lib/errors";

let isInitialized = false;

export const initializePosthog = () => {
  const debugPH = Config.posthog_debug;
  const apiKey = Config.posthog_key;
  const apiHost = Config.posthog_host;
  const disabled = Config.posthog_disabled;
  const tenant = Config.tenant;

  if (debugPH) {
    console.log("PostHog: Configuration check", {
      hasApiKey: !!apiKey,
      apiHost,
      disabled,
    });
  }

  if (debugPH && isInitialized) {
    console.warn("Posthog already initialized. You may be importing it incorrectly.");
  }

  if (apiKey && apiHost && !disabled && !isInitialized) {
    if (debugPH) {
      console.log("PostHog: Initializing with config", {
        apiKey: `${apiKey.substring(0, 10)}...`,
        apiHost,
      });
    }

    posthog.init(apiKey, {
      api_host: apiHost,
      autocapture: true,
      capture_pageview: "history_change",
      loaded: () => {
        isInitialized = true;
        if (tenant) {
          posthog.register({
            tenant: tenant,
          });
        }
        if (debugPH) console.log("PostHog: Successfully initialized and ready");
      },
    });
  }
};

export interface PostHogUser {
  email: string;
  tenant: string;
}

export const setPostHogUser = (user: PostHogUser): void => {
  if (!isInitialized) return;

  try {
    posthog.identify(user.email, {
      email: user.email,
      tenant: user.tenant,
    });
  } catch (error) {
    captureException(error, {
      tags: {
        operation: "posthog_user_identify",
        context: "setPostHogUser",
      },
    });
  }
};

export const resetPostHogUser = (): void => {
  if (!isInitialized) return;

  try {
    posthog.reset();
  } catch (error) {
    captureException(error, {
      tags: {
        operation: "posthog_user_reset",
        context: "resetPostHogUser",
      },
    });
  }
};

export { posthog };
